import api from '../../utils/axios.js';

const quotesByClientID = async (clientId, populate) => {
	const { data } = await api.get(
		`/quotes?search[clientId]=${clientId}${populate ? '&populate=true' : ''}`
	);

	return data;
};

const quoteByRelation = async (clientId, expertId) => {
	const { data } = await api.get(
		`/quotes?search[clientId]=${clientId}&search[expertId]=${expertId}`
	);

	return data;
};

const clientExpertRelationByClientID = async (clientId, populate) => {
	const { data } = await api.get(
		`/client-expert-relationships?search[clientId]=${clientId}${
			populate ? '&populate=true' : ''
		}`
	);

	return data;
};

const clientExpertRelationByExpertID = async (expertId, populate) => {
	const { data } = await api.get(
		`/client-expert-relationships?search[expertId]=${expertId}${
			populate ? '&populate=true' : ''
		}`
	);

	return data;
};

const createClientExpertRelation = async (quoteId, expertId, clientId) => {
	const { data } = await api.post(`/client-expert-relationships`, {
		clientId,
		expertId,
		quoteId,
		statusDate: new Date().toISOString(),
	});

	return data;
};

const updateClientExpertRelation = async (id, fields) => {
	const { data } = await api.patch(
		`/client-expert-relationships/${id}`,
		fields
	);

	return data;
};

const quoteService = {
	quotesByClientID,
	clientExpertRelationByClientID,
	clientExpertRelationByExpertID,
	createClientExpertRelation,
	updateClientExpertRelation,
	quoteByRelation,
};

export default quoteService;
